import { BaseStylesManipulator } from './BaseStyles';

export class DocumentStylesManipulator
  extends BaseStylesManipulator
  implements Editor.Edition.IDocumentStylesManipulator
{
  updateDocumentStyle(styleId: string, properties: Editor.Data.Structure.DocumentStyleProperties) {
    const StylesController = this.editionContext.DataManager?.styles;
    if (!StylesController?.documentStyles || !StylesController.documentStyles.loaded) {
      return;
    }

    if (!StylesController.documentStyles.style(styleId)) {
      StylesController.updateDocumentStyle(styleId, {
        id: styleId,
        p: {
          ...properties,
        },
      });
    } else {
      const style = StylesController.documentStyles.style(styleId);
      const data = { ...style.data };

      if (style.templateOnly) {
        data.p = properties;
      } else {
        data.p = {
          ...data.p,
          ...properties,
        };
      }

      // We don't want to send this to the server
      StylesController.updateDocumentStyle(styleId, data);
    }
  }
}
